module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.2f623b58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-dropdown.svg
// module id = 1543
// module chunks = 0